@if (visible && (display.visible$ | async)) {
  <button
    type="button"
    class="source-badge"
    [class.source-badge-outline]="!source!.exact"
    [attr.aria-label]="
      ('source.label.source' | translate) +
      ': ' +
      (ariaLabel(source!.exact) | translate)
    "
    (click)="toggle($event)"
    (mouseenter)="hoverStart($event)"
    (mouseleave)="hoverEnd()"
  >
    @if (source!.exact) {
      {{ abbreviations[source!.exact] }}
    } @else {
      @for (provider of outline; track provider; let last = $last) {
        {{ abbreviations[provider] }}
        @if (!last) {
          ·
        }
      }
    }
  </button>
  <app-overlay-panel #panel styleClass="source-popover" (closed)="closed()">
    <div class="source-popover-content" role="status">
      @if (label) {
        <div class="source-popover-label">{{ label | translate }}</div>
      }
      @if (source!.exact === 'manual') {
        <p>
          {{ 'source.label.manual' | translate }}
          @if (manual$ | async; as manual) {
            {{
              'source.label.manualBy'
                | translate
                  : {
                      user: manual.user,
                      date: (manual.date | date: 'mediumDate'),
                    }
            }}
            · {{ 'source.label.original' | translate }}
            {{ manual.original ?? '–' }}
          }
        </p>
        @if (editable) {
          <button
            type="button"
            class="source-edit-link"
            (click)="panel.hide(); editData.emit()"
          >
            <i class="fa-solid fa-pen" aria-hidden="true"></i>
            {{ 'source.action.editData' | translate }}
          </button>
        }
      } @else if (source!.exact) {
        <p>
          {{ 'source.label.source' | translate }}:
          <strong>{{ 'source.name.' + source!.exact | translate }}</strong>
          @if (source!.fallback) {
            ({{ 'source.label.fallback' | translate }})
          }
        </p>
      } @else {
        <p>{{ 'source.label.exactLater' | translate }}</p>
      }
      @if (others.length) {
        <p>
          {{ 'source.label.alsoDelivered' | translate }}:
          @for (provider of others; track provider; let last = $last) {
            {{ 'source.name.' + provider | translate
            }}{{
              provider === 'tracxn'
                ? ' (' + ('source.label.tracxnFrozen' | translate) + ')'
                : ''
            }}{{ last ? '' : ', ' }}
          }
        </p>
      }
      @if (lastUpdate$ | async; as lastUpdate) {
        <p class="source-popover-date">
          {{
            'common.label.lastDataUpdate'
              | translate: { value: (lastUpdate | date) }
          }}
        </p>
      }
    </div>
  </app-overlay-panel>
}
